"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class DashboardController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/dashboard',
            edit: '/v1/dashboard/:objectId',
            delete: '/v1/dashboard/:objectId',
            changeOwner: '/v1/dashboard/:dashboardId/owner',
        };
    }
    changeOwner(owner, dashboardId) {
        return this.manager.post({
            url: this.endpoints.changeOwner,
            params: { dashboardId },
        }, { user: owner });
    }
}
exports.default = DashboardController;
